import React from 'react';

export const suggestItemRender = (item, intl) => {
	const text = intl(item.text);
	const countryCode = item['country_code'].toLowerCase();

	return (
		<span className="filter-suggest-country-wrapper">
			<span className={`flag-icon flag-icon-${countryCode}`} />
			<span className="country-title font-proxima-nova-semibold">{text}</span>
			{ item.text !== item.originalText && (
				<span className="country-title--original">{item.originalText}</span>
			) }
		</span>
	);
};

export const labelItemRender = (item, intl) => {
	const text = intl(item.text);
	const countryCode = item['country_code'].toLowerCase();

	return (
		<span className="filter-label-country-wrapper">
			<span className={`flag-icon flag-icon-${countryCode}`} />
			<span className="country-title">{text}</span>
		</span>
	);
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/shared/filter-country-render.js